import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { useNavigate } from "react-router-dom";
import { isLottecardKtxReservationEnded } from "utils/lottecardServicePolicy";
import { getContextualUrl } from "utils/navigation";

const MyCartIcon = () => {
  const navigate = useNavigate();

  if (isLottecardKtxReservationEnded()) {
    return null;
  }

  return (
    <ShoppingCartIcon onClick={() => navigate(getContextualUrl("/cart"))} />
  );
};

export default MyCartIcon;
